<template>
  <div>
    <v-card
      v-if="scenarios"
      ref="bodyScenario"
      class="pt-3 mb-n2 hyp-risk-seerist-swirl hyp-risks-content-expanded"
    >
      <div class="hyp-risk-content-container">
        <div class="pb-3">
          <h1 class="pull-left pl-3 mr-3">Scenarios</h1>
          <SimpleDialog dialog-class="float-right" :show-sidebar="true">
            <template v-slot:dialogButton>
              <v-btn
                class="pull-right font-weight-bold mr-3 text-capitalize"
                color="success"
                outlined
                plain
                small
                rounded
              >
                <v-icon left small>
                  fas fa-info-circle
                </v-icon>
                Our Methodology
              </v-btn>
            </template>

            <template>
              <RisksProfileBody
                v-if="scenarioMethodology"
                :profile-info="scenarioMethodology"
              ></RisksProfileBody>
            </template>
          </SimpleDialog>
          <div class="clearfix"></div>
          <div class="ml-4 font-italic text-caption">
            {{ scenarios.updatedAt }}
          </div>
        </div>
        <div
          class="content-container"
          :class="[
            scenarios.alternative || scenarios.outlier
              ? 'hyp-scenarios-grid-3'
              : 'hyp-scenarios-grid-1',
          ]"
        >
          <!-- outlook overview -->
          <v-card flat v-if="scenarios.outlook">
            <h2 class="px-4 pt-4 font-weight-bold">Outlook</h2>
            <RisksScenariosOverview
              :scenario="scenarios.outlook"
              :title-min-height="minOverviewTitleHeight"
            ></RisksScenariosOverview>
          </v-card>

          <!-- alternative overview -->
          <v-card flat v-if="scenarios.alternative">
            <h2 class="px-4 pt-4 font-weight-bold">Alternative</h2>
            <RisksScenariosOverview
              :scenario="scenarios.alternative"
              :title-min-height="minOverviewTitleHeight"
            ></RisksScenariosOverview>
          </v-card>

          <!-- outlier overview -->
          <v-card flat v-if="scenarios.outlier">
            <h2 class="px-4 pt-4 font-weight-bold">Outlier</h2>
            <RisksScenariosOverview
              :scenario="scenarios.outlier"
              :title-min-height="minOverviewTitleHeight"
            ></RisksScenariosOverview>
          </v-card>

          <!-- Triggers -->
          <v-card
            flat
            v-if="
              (scenarios.outlook &&
                scenarios.outlook.triggers &&
                scenarios.outlook.triggers.length) ||
              (scenarios.alternative &&
                scenarios.alternative.triggers &&
                scenarios.alternative.triggers.length) ||
              (scenarios.outlier &&
                scenarios.outlier.triggers &&
                scenarios.outlier.triggers.length)
            "
          >
            <RisksScenariosTriggers
              :triggers="scenarios.outlook.triggers"
            ></RisksScenariosTriggers>
          </v-card>
          <v-card
            flat
            v-if="
              (scenarios.alternative &&
                scenarios.alternative.triggers &&
                scenarios.alternative.triggers.length) ||
              (scenarios.outlier &&
                scenarios.outlier.triggers &&
                scenarios.outlier.triggers.length)
            "
          >
            <RisksScenariosTriggers
              title="Alternative"
              :triggers="scenarios.alternative.triggers"
            ></RisksScenariosTriggers>
          </v-card>
          <v-card
            flat
            v-if="
              (scenarios.alternative &&
                scenarios.alternative.triggers &&
                scenarios.alternative.triggers.length) ||
              (scenarios.outlier &&
                scenarios.outlier.triggers &&
                scenarios.outlier.triggers.length)
            "
          >
            <RisksScenariosTriggers
              title="Outlier"
              :triggers="scenarios.outlier.triggers"
            ></RisksScenariosTriggers>
          </v-card>

          <!-- RiskTypeImpacts  -->
          <RisksScenariosRiskTypeImpacts
            v-if="
              (scenarios.outlook &&
                scenarios.outlook.riskTypeImpacts &&
                scenarios.outlook.riskTypeImpacts.length) ||
              (scenarios.alternative &&
                scenarios.alternative.riskTypeImpacts &&
                scenarios.alternative.riskTypeImpacts.length) ||
              (scenarios.outlier &&
                scenarios.outlier.riskTypeImpacts &&
                scenarios.outlier.riskTypeImpacts.length)
            "
            title="Outlook"
            :scenarios="scenarios"
          ></RisksScenariosRiskTypeImpacts>

          <!-- Geographies -->
          <v-card
            flat
            v-if="
              (scenarios.outlook &&
                scenarios.outlook.geographyImpacts &&
                scenarios.outlook.geographyImpacts.length) ||
              (scenarios.alternative &&
                scenarios.alternative.geographyImpacts &&
                scenarios.alternative.geographyImpacts.length) ||
              (scenarios.outlier &&
                scenarios.outlier.geographyImpacts &&
                scenarios.outlier.geographyImpacts.length)
            "
          >
            <RisksScenariosOtherImpacts
              title="Geographies"
              :other-impacts="scenarios.outlook.geographyImpacts"
            ></RisksScenariosOtherImpacts>
          </v-card>
          <v-card
            flat
            v-if="
              (scenarios.alternative &&
                scenarios.alternative.geographyImpacts &&
                scenarios.alternative.geographyImpacts.length) ||
              (scenarios.outlier &&
                scenarios.outlier.geographyImpacts &&
                scenarios.outlier.geographyImpacts.length)
            "
          >
            <RisksScenariosOtherImpacts
              title="Alternative Geographies"
              :other-impacts="scenarios.alternative.geographyImpacts"
            ></RisksScenariosOtherImpacts>
          </v-card>
          <v-card
            flat
            v-if="
              (scenarios.alternative &&
                scenarios.alternative.geographyImpacts &&
                scenarios.alternative.geographyImpacts.length) ||
              (scenarios.outlier &&
                scenarios.outlier.geographyImpacts &&
                scenarios.outlier.geographyImpacts.length)
            "
          >
            <RisksScenariosOtherImpacts
              title="Outlier Geographies"
              :other-impacts="scenarios.outlier.geographyImpacts"
            ></RisksScenariosOtherImpacts>
          </v-card>

          <!-- Sectors -->
          <v-card
            flat
            v-if="
              (scenarios.outlook &&
                scenarios.outlook.sectorImpacts &&
                scenarios.outlook.sectorImpacts.length) ||
              (scenarios.alternative &&
                scenarios.alternative.sectorImpacts &&
                scenarios.alternative.sectorImpacts.length) ||
              (scenarios.outlier &&
                scenarios.outlier.sectorImpacts &&
                scenarios.outlier.sectorImpacts.length)
            "
          >
            <RisksScenariosOtherImpacts
              title="Sectors"
              :other-impacts="scenarios.outlook.sectorImpacts"
            ></RisksScenariosOtherImpacts>
          </v-card>
          <v-card
            flat
            v-if="
              (scenarios.alternative &&
                scenarios.alternative.sectorImpacts &&
                scenarios.alternative.sectorImpacts.length) ||
              (scenarios.outlier &&
                scenarios.outlier.sectorImpacts &&
                scenarios.outlier.sectorImpacts.length)
            "
          >
            <RisksScenariosOtherImpacts
              title="Alternative Sectors"
              :other-impacts="scenarios.alternative.sectorImpacts"
            ></RisksScenariosOtherImpacts>
          </v-card>
          <v-card
            flat
            v-if="
              (scenarios.alternative &&
                scenarios.alternative.sectorImpacts &&
                scenarios.alternative.sectorImpacts.length) ||
              (scenarios.outlier &&
                scenarios.outlier.sectorImpacts &&
                scenarios.outlier.sectorImpacts.length)
            "
          >
            <RisksScenariosOtherImpacts
              title="Outlier Sectors"
              :other-impacts="scenarios.outlier.sectorImpacts"
            ></RisksScenariosOtherImpacts>
          </v-card>

          <!-- Foreign Relations -->
          <v-card
            flat
            v-if="
              (scenarios.outlook &&
                scenarios.outlook.foreignRelationImpacts &&
                scenarios.outlook.foreignRelationImpacts.length) ||
              (scenarios.alternative &&
                scenarios.alternative.foreignRelationImpacts &&
                scenarios.alternative.foreignRelationImpacts.length) ||
              (scenarios.outlier &&
                scenarios.outlier.foreignRelationImpacts &&
                scenarios.outlier.foreignRelationImpacts.length)
            "
          >
            <RisksScenariosOtherImpacts
              title="Foreign Relations"
              :other-impacts="scenarios.outlook.foreignRelationImpacts"
            ></RisksScenariosOtherImpacts>
          </v-card>
          <v-card
            flat
            v-if="
              (scenarios.alternative &&
                scenarios.alternative.foreignRelationImpacts &&
                scenarios.alternative.foreignRelationImpacts.length) ||
              (scenarios.outlier &&
                scenarios.outlier.foreignRelationImpacts &&
                scenarios.outlier.foreignRelationImpacts.length)
            "
          >
            <RisksScenariosOtherImpacts
              title="Alternative Foreign Relations"
              :other-impacts="scenarios.alternative.foreignRelationImpacts"
            ></RisksScenariosOtherImpacts>
          </v-card>
          <v-card
            flat
            v-if="
              (scenarios.alternative &&
                scenarios.alternative.foreignRelationImpacts &&
                scenarios.alternative.foreignRelationImpacts.length) ||
              (scenarios.outlier &&
                scenarios.outlier.foreignRelationImpacts &&
                scenarios.outlier.foreignRelationImpacts.length)
            "
          >
            <RisksScenariosOtherImpacts
              title="Outlier Foreign Relations"
              :other-impacts="scenarios.outlier.foreignRelationImpacts"
            ></RisksScenariosOtherImpacts>
          </v-card>
        </div>
      </div>
    </v-card>
    <v-row v-if="!scenarios && !loading">
      <v-col cols="12">
        We do not currently provide scenarios on this country. Please
        <a :href="`mailto:${SUPPORT_EMAIL}`">contact our team</a> if you are
        interested.
      </v-col>
    </v-row>
    <Loader v-if="loading" text="" color="black" />
  </div>
</template>

<script>
import { SUPPORT_EMAIL } from "@/common/constants/misc";
import { getScenarioMethodology } from "@/services/common/methodology.service";
import { getCountryScenarios } from "@/services/controlRisks/risks.service";
import { getFormatted } from "@/common/date.utilities";

export default {
  name: "RisksCountryScenarios",
  components: {
    RisksProfileBody: () =>
      import("@/components/controlRisks/risks/RisksProfileBody"),
    RisksScenariosOverview: () =>
      import("@/components/controlRisks/risks/RisksScenariosOverview"),
    RisksScenariosTriggers: () =>
      import("@/components/controlRisks/risks/RisksScenariosTriggers"),
    RisksScenariosRiskTypeImpacts: () =>
      import("@/components/controlRisks/risks/RisksScenariosRiskTypeImpacts"),
    RisksScenariosOtherImpacts: () =>
      import("@/components/controlRisks/risks/RisksScenariosOtherImpacts"),
    SimpleDialog: () => import("@/components/common/dialogs/SimpleDialog"),
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    selectedLocation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      scenarios: null,
      scenarioMethodology: null,
      minOverviewTitleHeight: "auto",
    };
  },
  created() {
    this.SUPPORT_EMAIL = SUPPORT_EMAIL;
  },
  async mounted() {
    this.scenarioMethodology = await getScenarioMethodology();
  },
  methods: {
    async getScenarios(countryCode) {
      try {
        this.loading = true;
        this.scenarios = await getCountryScenarios(countryCode);
        this.loading = false;
        if (
          this.scenarios?.outlook ||
          this.scenarios?.alternative ||
          this.scenarios?.outlier
        ) {
          this.scenarios.updatedAt = this.scenarios?.updatedAt
            ? getFormatted(this.scenarios.updatedAt)
            : null;
          this.minOverviewTitleHeight =
            this.scenarios.alternative || this.scenarios.outlier
              ? "80"
              : "auto";
        } else {
          this.scenarios = null;
        }
      } catch (error) {
        this.loading = false;
        console.error(
          "There was an error trying to retrieve the scenarios for country: " +
            countryCode
        );
      }
      return true;
    },
  },
  watch: {
    selectedLocation: {
      async handler() {
        this.scenarios = null;
        if (this.selectedLocation && this.selectedLocation.iso2Code) {
          await this.getScenarios(this.selectedLocation.iso2Code);
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
.hyp-risk-tab-items {
  height: calc(100vh - 130px);
  max-height: calc(100vh - 130px);
}
.details-heading {
  font-size: 24px;
}
.content-container {
  max-width: unset !important;
  font-size: 14px;
}
.hyp-risks-content-expanded {
  min-height: 80vh;
}
.hyp-risks-content-expanded.hyp-risk-seerist-swirl .content-container {
  padding: 0px !important;
}
>>> .risk-impact-card,
.hyp-risks-content-expanded .content-container > .v-card {
  overflow-y: unset !important;
  padding-bottom: unset !important;
  position: relative;
}
.hyp-scenarios-grid-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.hyp-scenarios-grid-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.hyp-scenarios-grid-1,
.hyp-scenarios-grid-3 {
  --gap: 1em;
  --line-offset: calc(var(--gap) / 2);
  --line-thickness: 1px;
  --line-color: #cccccc;
  display: grid;
  overflow: hidden;
  gap: var(--gap);
  border-top: 1px solid #cccccc;
}
>>> .risk-impact-card::before,
.hyp-risks-content-expanded .content-container > .v-card::before {
  content: "";
  position: absolute;
  background-color: var(--line-color);
  z-index: 1;
  inline-size: var(--line-thickness);
  block-size: 110%;
  inset-block-start: 0;
  inset-inline-start: calc(var(--line-offset) * -1);
}
>>> .risk-impact-card::after,
.hyp-risks-content-expanded .content-container > .v-card::after {
  content: "";
  position: absolute;
  background-color: var(--line-color);
  z-index: 1;
  inline-size: 100vw;
  block-size: var(--line-thickness);
  inset-inline-start: 0;
  inset-block-start: calc(var(--line-offset) * -1);
}
.v-application .font-weight-bold {
  font-weight: 700 !important;
}
</style>
